import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ShortageRecoveryService {
  private apiUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_RECOVERY}`;

  constructor(private http: HttpClient) { }

  getShortageRecovery(email: string): Observable<any> {
    return this.http.get(`${this.apiUrl}?user_email=${email}`);
  }
}
